import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { MatTab } from '@angular/material/tabs';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { UserType, } from '@models';
import { ProvisionRobotComponent } from '@pages/users/components/provision-robot/provision-robot.component';
import { RoleService, UserService, } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, of, } from 'rxjs';
import { finalize, switchMap, } from 'rxjs/operators';
export var UserGroupField;
(function (UserGroupField) {
    UserGroupField["Domain"] = "domain";
    UserGroupField["OrganizationUnits"] = "organizationUnits";
    UserGroupField["MayHaveRobotSession"] = "mayHaveRobotSession";
    UserGroupField["MayHaveUserSession"] = "mayHaveUserSession";
    UserGroupField["Robot"] = "robotProvision";
    UserGroupField["Roles"] = "rolesList";
    UserGroupField["Type"] = "type";
    UserGroupField["UserName"] = "userName";
})(UserGroupField || (UserGroupField = {}));
var UserGroupImportModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UserGroupImportModalComponent, _super);
    function UserGroupImportModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.UserGroupField = UserGroupField;
        _this.UserType = UserType;
        _this.loading$ = new BehaviorSubject(false);
        _this.isAdSearchLoading = true;
        _this._appState = _this._injector.get(AppStateFacade);
        _this._userService = _this._injector.get(UserService);
        _this._roleService = _this._injector.get(RoleService);
        _this.roleSearchFactory = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this._appState.user.permissions
                .isGranted('Roles.View')
                .pipe(switchMap(function (result) { return result ?
                _this._roleService.suggest.apply(null, args) :
                of({ data: [], total: 0 }); }));
        };
        return _this;
    }
    Object.defineProperty(UserGroupImportModalComponent.prototype, "provisionRobot", {
        set: function (value) {
            if (!value) {
                this.form.removeControl(UserGroupField.Robot);
                return;
            }
            this.form.addControl(UserGroupField.Robot, value.form);
        },
        enumerable: true,
        configurable: true
    });
    UserGroupImportModalComponent.prototype.ngOnInit = function () {
        var _a;
        this.form = this._injector.get(FormBuilder).group((_a = {},
            _a[UserGroupField.UserName] = [[]],
            _a[UserGroupField.Domain] = [[]],
            _a[UserGroupField.Type] = [],
            _a[UserGroupField.MayHaveUserSession] = [true],
            _a[UserGroupField.Roles] = [[]],
            _a[UserGroupField.OrganizationUnits] = [[]],
            _a[UserGroupField.MayHaveRobotSession] = [false],
            _a));
        this.isRobotSwitcherEnabled$ = this._appState.user.permissions.isGranted('Robots.Create');
    };
    UserGroupImportModalComponent.prototype.onSubmit = function () {
        var _a;
        var _this = this;
        if (!this.form.valid ||
            this.loading$.value) {
            return;
        }
        this.loading$.next(true);
        var payload = cloneDeep(this.form.value);
        Object.assign(payload, (_a = {},
            _a[UserGroupField.Domain] = this.form.get(UserGroupField.Domain).value[0].id,
            _a[UserGroupField.UserName] = this.form.get(UserGroupField.UserName).value[0].id,
            _a[UserGroupField.Roles] = this.form.get(UserGroupField.Roles)
                .value.map(function (item) { return item.text; }),
            _a));
        // FIXME: implement this in a better way
        if (payload.robotProvision) {
            payload.licenseType = payload.robotProvision.type;
            payload.isExternalLicensed = payload.robotProvision.isExternalLicensed;
            delete payload.robotProvision.type;
            delete payload.robotProvision.isExternalLicensed;
        }
        this._userService.add(payload)
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function () {
            return _this._dialogRef.close({
                type: 1 /* Add */,
            });
        });
    };
    return UserGroupImportModalComponent;
}(UiModalComponent));
export { UserGroupImportModalComponent };
